export default "__VITE_ASSET__2ff6c183__"